/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 16.05.2016.
 */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import DocumentTitle from 'react-document-title';
import Translate from '../components/Translate';

import _get from 'lodash/get';

import ShowcaseCollection from '../containers/ShowcaseCollection';

import {GetPackages} from '../actions/collection/actions-collection';

class ShowcaseCollectionRoute extends Component {

  componentWillMount() {
    this.props.GetPackages();
  }

  render() {

    return (<DocumentTitle title={_get(this.props, 'params.url', '')}>
      <ShowcaseCollection
        id={'showcase_' + _get(this.props, 'params.url', '')}
        url={_get(this.props, 'params.url', '')}
        isDynamic={_get(this.props, 'route.metadata.isDynamic', false)}
        startLimit={_get(this.props, 'route.metadata.nextLimit', 18)}
        nextLimit={_get(this.props, 'route.metadata.startLimit', 18)}
        isPreview={false}
      >
      </ShowcaseCollection>
    </DocumentTitle>);
  }
}

const mapDispatchToProps = function (dispatch) {

  return bindActionCreators({GetPackages}, dispatch);
};

export default connect(() => ({}), mapDispatchToProps)(ShowcaseCollectionRoute);



// WEBPACK FOOTER //
// ./src/routes/showcase-collection-route.js